import { Pane, Heading, TextInputField, Button, majorScale, toaster } from 'evergreen-ui';
import { NewPersonIcon, Select, FormField } from 'evergreen-ui';
import { addCollaborator } from '../services/collaboratorServices';

const AddCollaboratorForm = ({ newCollaborator, setNewCollaborator, setCollaborators }) => {
    
    const defaultCollaborator = {
        email: '',
        password: '',
        nome: '',
        cognome: '',
        role: 'operatore'
    };

    const collaborator = { ...defaultCollaborator, ...newCollaborator };

    const handleAddCollaborator = async () => {
        try {
            if (!collaborator.role || collaborator.role.trim() === '') {
                collaborator.role = 'operatore';
            }

            let addedCollaborator = await addCollaborator(collaborator);

            if (typeof addedCollaborator === 'string') {
                try {
                    addedCollaborator = JSON.parse(addedCollaborator);
                } catch (error) {
                    console.error('Errore nel parsing della risposta del server:', error);
                    toaster.danger('Errore nella risposta del server.');
                    return;
                }
            }

            toaster.success('Collaboratore aggiunto con successo.');

            setCollaborators((prevCollaborators) => [
                ...(Array.isArray(prevCollaborators) ? prevCollaborators : []),
                { ...collaborator, id: addedCollaborator.id }
            ]);

            setNewCollaborator(defaultCollaborator);
        } catch (error) {
            console.error('Errore nell\'aggiunta del collaboratore:', error);
            toaster.danger('Errore nell\'aggiunta del collaboratore.');
        }
    };

    return (
        <Pane marginTop={majorScale(4)}>
            <Heading size={600} marginBottom={16}>
                Aggiungi nuovo collaboratore
            </Heading>
            <TextInputField
                label="Email"
                placeholder="Inserisci l'email per il nuovo collaboratore..."
                value={collaborator.email}
                onChange={(e) => setNewCollaborator({ ...collaborator, email: e.target.value })}
                marginBottom={16}
            />
            <TextInputField
                label="Password"
                placeholder="Inserisci la password per il nuovo collaboratore..."
                value={collaborator.password}
                onChange={(e) => setNewCollaborator({ ...collaborator, password: e.target.value })}
                marginBottom={16}
            />
            <TextInputField
                label="Nome"
                placeholder="Inserisci il nome del nuovo collaboratore..."
                value={collaborator.nome}
                onChange={(e) => setNewCollaborator({ ...collaborator, nome: e.target.value })}
                marginBottom={16}
            />
            <TextInputField
                label="Cognome"
                placeholder="Inserisci il cognome del nuovo collaboratore..."
                value={collaborator.cognome}
                onChange={(e) => setNewCollaborator({ ...collaborator, cognome: e.target.value })}
                marginBottom={16}
            />
            <FormField
                label="Ruolo"
                marginBottom={16}
            >
                <Select
                    id="role-select"
                    value={collaborator.role}
                    onChange={(e) => setNewCollaborator({ ...collaborator, role: e.target.value })}
                >
                    <option value="operatore">Operatore</option>
                    <option value="educatore">Educatore</option>
                </Select>
            </FormField>
            <Pane marginTop="0.5rem">
                <Button appearance="primary" intent="success" onClick={handleAddCollaborator} marginTop={majorScale(2)}>
                    Aggiungi collaboratore <NewPersonIcon marginLeft={8} />
                </Button>
            </Pane>
        </Pane>
    );
};

export default AddCollaboratorForm;